if (!customElements.get('lifestyle-category-carousel')) {
  class LifestyleCategoryCarousel extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('.lifestyle-carousel__panel'));
      this.lists = Array.from(this.querySelectorAll('.lifestyle-carousel__list'));

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.activate(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.addEventListener('click', this.onClickCapture, true);
      this.addEventListener('pointerdown', this.onPointerDown);
      this.addEventListener('dragstart', this.onDragStart);
      document.addEventListener('pointermove', this.onPointerMove);
      document.addEventListener('pointerup', this.onPointerUp);
      document.addEventListener('pointercancel', this.onPointerUp);

      if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('pointermove', this.onPointerMove);
      document.removeEventListener('pointerup', this.onPointerUp);
      document.removeEventListener('pointercancel', this.onPointerUp);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    activate(index, focus = false) {
      if (!this.tabs[index]) return;

      this.tabs.forEach((tab, tabIndex) => {
        const selected = tabIndex === index;
        tab.setAttribute('aria-selected', selected);
        tab.tabIndex = selected ? 0 : -1;
      });

      const panelId = this.tabs[index].getAttribute('aria-controls');
      this.panels.forEach((panel) => {
        panel.hidden = panel.id !== panelId;
        if (!panel.hidden) {
          const list = panel.querySelector('.lifestyle-carousel__list');
          if (list) list.scrollLeft = 0;
        }
      });

      this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (focus) this.tabs[index].focus();
    }

    onKeydown(event, index) {
      const last = this.tabs.length - 1;
      let next = null;

      if (event.key === 'ArrowRight') next = index === last ? 0 : index + 1;
      if (event.key === 'ArrowLeft') next = index === 0 ? last : index - 1;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = last;
      if (next === null) return;

      event.preventDefault();
      this.activate(next, true);
    }

    // Theme editor: show the tab that owns the selected tab or card block.
    onBlockSelect = (event) => {
      if (!this.contains(event.target)) return;

      let index = this.tabs.indexOf(event.target);
      if (index === -1) {
        const panel = event.target.closest('.lifestyle-carousel__panel');
        index = this.tabs.findIndex((tab) => panel && tab.getAttribute('aria-controls') === panel.id);
      }
      if (index !== -1) this.activate(index);
    };

    // Mouse drag-to-scroll for rows that overflow; touch uses native scrolling.
    onPointerDown = (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      const list = event.target.closest('.lifestyle-carousel__list');
      if (!list || list.scrollWidth <= list.clientWidth) return;

      this.drag = { list, startX: event.clientX, startScroll: list.scrollLeft, moved: false };
    };

    onPointerMove = (event) => {
      if (!this.drag) return;

      const delta = event.clientX - this.drag.startX;
      if (!this.drag.moved && Math.abs(delta) < 5) return;

      this.drag.moved = true;
      this.drag.list.classList.add('is-dragging');
      this.drag.list.scrollLeft = this.drag.startScroll - delta;
    };

    onPointerUp = () => {
      if (!this.drag) return;

      this.drag.list.classList.remove('is-dragging');
      this.suppressClick = this.drag.moved;
      this.drag = null;
      // The click that ends a drag fires right after pointerup.
      setTimeout(() => {
        this.suppressClick = false;
      });
    };

    onClickCapture = (event) => {
      if (!this.suppressClick) return;

      event.preventDefault();
      event.stopPropagation();
      this.suppressClick = false;
    };

    onDragStart = (event) => {
      if (event.target.closest('.lifestyle-carousel__list')) event.preventDefault();
    };
  }

  customElements.define('lifestyle-category-carousel', LifestyleCategoryCarousel);
}
